module.exports = __webpack_public_path__ + "media/iconic/person-7aaf3bd8.svg";